import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useAuth } from '@langmail/shared-ui'

export const Reconnect = () => {
  const { signInWithGoogle } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const reconnect = async () => {
      const { error } = await signInWithGoogle({ isReconnect: true })
      if (error) {
        navigate('/login?error=oauth_failed')
      }
    }

    reconnect()
  }, [signInWithGoogle, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <div className="mb-4 font-medium text-foreground text-xl">Redirecting to Google...</div>
        <div className="text-muted-foreground text-sm">Please wait while we reconnect your account</div>
      </div>
    </div>
  )
}
